"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _lodash = require("lodash");
var _bowser = _interopRequireDefault(require("bowser"));
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _models = require("@seedlang/models");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MAX_AUDIO_LEVEL = 100;
var LEVEL_MULTIPLIER = 230;
var supportedMimeType = function supportedMimeType() {
  var mimeTypes = ['video/webm;codecs=vp8', 'video/webm'];
  var selectedMimeType = '';
  mimeTypes.some(function (mimeType) {
    if (MediaRecorder.isTypeSupported(mimeType)) {
      selectedMimeType = mimeType;
      return true;
    }
    return false;
  });
  return selectedMimeType;
};
var VideoRecorderStore = (_class = /*#__PURE__*/function () {
  function VideoRecorderStore() {
    var _this = this;
    var _params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, VideoRecorderStore);
    (0, _initializerDefineProperty2["default"])(this, "audioStreamInstantiated", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "objectUrl", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "isRecording", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "audioLevel", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "maxAudioLevel", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "data", _descriptor6, this);
    (0, _initializerDefineProperty2["default"])(this, "stream", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "secondsElapsed", _descriptor8, this);
    (0, _initializerDefineProperty2["default"])(this, "startRecordingTimestamp", _descriptor9, this);
    (0, _initializerDefineProperty2["default"])(this, "endRecordingTimestamp", _descriptor0, this);
    this.setupVideo = function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      var mediaParams = _objectSpread({
        audio: true,
        video: true
      }, params);
      if (_this.isRecording) {
        _this.stopRecording();
      }
      _this.clearVideoStream();
      _this.clearAudioStream();
      _this.afterDeviceGrantedAccess = callback;
      _this.resetRecorderState();
      if (!_bowser["default"].ios && !_bowser["default"].safari) {
        (0, _utils.getUserMedia)(mediaParams, _this.onDeviceGrantedAccess, _this.onDeviceDeniedAccess);
      }
    };
    this.onDeviceGrantedAccess = function (stream) {
      _this.clearObjectUrl();
      _this.stream = stream;
      _this.streams = [stream];
      _this.setupRecorder();
      if ((0, _lodash.isFunction)(_this.afterDeviceGrantedAccess)) {
        _this.afterDeviceGrantedAccess(stream);
      }
    };
    this.setupRecorder = function () {
      if (!_this.stream) {
        return;
      }
      if (!_this.audioStreamInstantiated) {
        _this.audioStreamInstantiated = true;
        _this.audioStream = new _models.AudioStream();
        _this.audioStream.onStreamSuccess(_this.stream, _this.onAudioLevelUpdate);
      }
      _this.recorder = _this.createRecorder(_this.stream);
    };
    this.startRecording = function () {
      if (!_this.recorder || !_this.stream) {
        return;
      }
      _this.resetDataBuffers();
      _this.startRecordingTimestamp = +new Date();
      _this.startSecondsElapsed();
      _this.isRecording = true;
      if (_this.audioStream) {
        _this.audioStream.startMonitor();
      }
      _this.recorder.start(10); // 10 ms chunks
    };
    this.stopRecording = function () {
      if (!_this.isRecording) {
        return;
      }
      _this.stopSecondsElapsed();
      _this.isRecording = false;
      _this.endRecordingTimestamp = +new Date();
      if (_this.audioStream) {
        _this.audioStream.stopMonitor();
      }
      if (_this.recorder && _this.recorder.state !== 'inactive') {
        _this.recorder.stop();
      }
      if (_this.data.length > 0) {
        _this.objectUrl = _this.createObjectURL(_this.createBlob());
      }
    };
    this.startSecondsElapsed = function () {
      clearInterval(_this.interval);
      _this.secondsElapsed = 0;
      _this.interval = setInterval(function () {
        return _this.secondsElapsed += 1;
      }, 1000);
    };
    this.stopSecondsElapsed = function () {
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = null;
      }
    };
    this.onHandleData = function (event) {
      if (_this.isRecording && event.data && event.data.size > 0) {
        _this.data.push(event.data);
      }
    };
    this.onAudioLevelUpdate = function (level) {
      _this.audioLevel = level;
      if (_this.normalizedAudioLevel > _this.maxAudioLevel) {
        _this.maxAudioLevel = _this.normalizedAudioLevel;
      }
    };
    this.getFormData = function () {
      var formData = new FormData();
      formData.append('blob', _this.createBlob());
      return formData;
    };
    this.createBlob = function () {
      return new Blob(_this.data, {
        type: 'video/webm'
      });
    };
    this.createObjectURL = function (file) {
      if (window.webkitURL) {
        return window.webkitURL.createObjectURL(file);
      }
      if (window.URL && window.URL.createObjectURL) {
        return window.URL.createObjectURL(file);
      }
      return null;
    };
    this.clearVideoStream = function () {
      _this.stopTracksByKind('video');
      _this.stream = null;
    };
    this.clearAudioStream = function () {
      if (_this.audioStream) {
        _this.audioStream.cleanup();
        _this.audioStream = null;
      }
      _this.audioStreamInstantiated = false;
      _this.stopTracksByKind('audio');
      _this.streams = [];
      _this.stream = null;
      _this.resetRecorderState();
    };
    this.stopTracksByKind = function (kind) {
      (0, _lodash.each)(_this.streams, function (stream) {
        stream.getTracks().forEach(function (track) {
          if (!kind || track.kind === kind) {
            track.stop();
          }
        });
      });
    };
    this.clearObjectUrl = function () {
      if (_this.objectUrl && window.URL && window.URL.revokeObjectURL) {
        window.URL.revokeObjectURL(_this.objectUrl);
      }
      _this.objectUrl = null;
    };
    this.resetRecorderState = function () {
      _this.clearObjectUrl();
      _this.data = [];
      _this.maxAudioLevel = 0;
      _this.audioLevel = 0;
      _this.secondsElapsed = 0;
      _this.startRecordingTimestamp = null;
      _this.endRecordingTimestamp = null;
      _this.recorder = null;
    };
    this.resetDataBuffers = function () {
      _this.data = [];
      _this.maxAudioLevel = 0;
      _this.audioLevel = 0;
      _this.secondsElapsed = 0;
    };
    this.dispose = function () {
      if (_this.isRecording) {
        _this.stopRecording();
      }
      _this.clearVideoStream();
      _this.clearAudioStream();
      _this.clearObjectUrl();
    };
    this.onDeviceDeniedAccess = function () {
      if (_this.parent && (0, _lodash.isFunction)(_this.parent.set)) {
        _this.parent.set('deviceDeniedAccess', true);
      }
    };
    this.createRecorder = function (stream) {
      var options = {
        mimeType: supportedMimeType(),
        audioBitsPerSecond: _constants.Constants.AUDIO_BITS_PER_SECOND,
        videoBitsPerSecond: _constants.Constants.VIDEO_BITS_PER_SECOND
      };
      var recorder = new MediaRecorder(stream, options);
      recorder.ondataavailable = _this.onHandleData;
      return recorder;
    };
    this.parent = _params.parent;
    this.streams = [];
  }
  return (0, _createClass2["default"])(VideoRecorderStore, [{
    key: "normalizedAudioLevel",
    get: function get() {
      var level = Math.round(this.audioLevel * LEVEL_MULTIPLIER);
      if (level > MAX_AUDIO_LEVEL) {
        level = MAX_AUDIO_LEVEL;
      }
      return level;
    }
  }, {
    key: "duration",
    get: function get() {
      if (this.endRecordingTimestamp && this.startRecordingTimestamp) {
        var durationMs = this.endRecordingTimestamp - this.startRecordingTimestamp;
        if (durationMs > 0) {
          return Math.round(durationMs / 1000 * 10) / 10;
        }
      }
      return null;
    }
  }, {
    key: "hasObjectUrl",
    get: function get() {
      return (0, _utils.isPresent)(this.objectUrl);
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioStreamInstantiated", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "objectUrl", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isRecording", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "maxAudioLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "stream", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "secondsElapsed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "startRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor0 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "endRecordingTimestamp", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "normalizedAudioLevel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "normalizedAudioLevel"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "duration", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "duration"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasObjectUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasObjectUrl"), _class.prototype), _class);
var _default = exports["default"] = VideoRecorderStore;